import React from 'react';
import { useSelector } from 'react-redux';
import './TermsAndConditions.css';
import Navbar from '../../Common/Navbar/Navbar';
import Footer from '../../Common/Footer/Footer';

import privacyPolicyContent from "../../Services/PrivacyPolicy";

const Privacy = () => {
  const isDark = useSelector((state) => state.functionslice.value.isDark);
  return (
    <>
    <Navbar />

    <div className={`privacy-container terms-content ${isDark ? 'dark-theme' : ''}`}>

      <header className="terms-header">
        <h1>{privacyPolicyContent.title}</h1>
      </header>

      <section className="terms-section">

      <p><strong>Effective Date:</strong> {privacyPolicyContent.effectiveDate}</p>
      <br></br>

      {privacyPolicyContent.sections.map((section, index) => (
        <div key={index} className="privacy-section">
          <h2>{section.heading}</h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {section.content}
          </p>
          <br></br>
        </div>
      ))}

      </section>
    </div>

    <Footer />
    </>
  );
};

export default Privacy;